// How many sources can be searched at once. Each source is another upstream call per search
// (and the results wait on the slowest one), so this is a performance guard, not just a perk.
// Everyone gets the same number of sources (owner, 2026-10-23): the number of sources is NOT a paid perk, so paid tiers never sell access to
// third-party media (processors judge a membership by everything it gives access to). Raise both together if people ask.
export const FREE_MAX_SOURCES = 6
export const PAID_MAX_SOURCES = 6

export function getMaxSources(isPremium: boolean): number {
  return isPremium ? PAID_MAX_SOURCES : FREE_MAX_SOURCES
}
